import PropTypes from 'prop-types';

const JsonLd = ({data}) => {
    const verified_data = {};

    // "it is more important to supply fewer but complete and accurate recommended properties rather than trying to
    // provide every possible recommended property with less complete, badly-formed, or inaccurate data"
    // so we filter out any null or undefined values that may have been passed in
    for (let key in data) {
        if (data.hasOwnProperty(key)
            && typeof data[key] !== 'undefined'
            && !(typeof data[key] === 'string' && data[key].length === 0)
        ) {
            verified_data[key] = data[key];
        }
    }

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(verified_data)}} />;
};

JsonLd.propTypes = {
    data: PropTypes.object.isRequired,
};

export default JsonLd;
